import darkMode from './darkMode';
import { TRANSIT_DOMAIN, EXPLORER_TRANSIT_DOMAIN } from '../utils/config';
export default {
  mixins: [darkMode],
  computed: {
    swapUrl() {
      return `${TRANSIT_DOMAIN}/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}#/`;
    },
    swapMarketUrl() {
      return `${TRANSIT_DOMAIN}/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}#/market`;
    },
    transitBuyUrl() {
      return `https://buy.transit.finance/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}`
    },
    transitExplorerUrl() {
      return `${EXPLORER_TRANSIT_DOMAIN}/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}`
    },
    transitBridgeUrl() {
      const query = `inputChain=ETH&inputSymbol=ETH&outputChain=BSC&outputSymbol=BNB&market=0#/`
      // return `${TRANSIT_DOMAIN}/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}&${query}`
      return `${TRANSIT_DOMAIN}/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}#/dex`
    },
    transitAdvancedUrl() {
      const query = `inputChain=ETH&inputSymbol=ETH&outputChain=ETH&outputCurrency=0xdac17f958d2ee523a2206206994597c13d831ec7&outputSymbol=USDT&market=1#/`
      // return `${TRANSIT_DOMAIN}/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}&${query}`
      return `${TRANSIT_DOMAIN}/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}#/chart`
    },
  },
};
